import { render, staticRenderFns } from "./about.vue?vue&type=template&id=493e778b&scoped=true&"
import script from "./about.vue?vue&type=script&lang=js&"
export * from "./about.vue?vue&type=script&lang=js&"
import style1 from "./about.vue?vue&type=style&index=1&id=493e778b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e778b",
  null
  
)

export default component.exports